// Un objeto de funciones con identidad FIJA que siempre llama a la última versión de cada una. Para pasar manejadores a
// componentes con React.memo (o a efectos) sin que una lambda nueva en cada render los vuelva a pintar. Solo para
// manejadores de eventos: no se llaman durante el render. Las claves no pueden cambiar entre renders.
import { useMemo, useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Funciones = Record<string, (...args: any[]) => unknown>;

export function useAccionesEstables<T extends Funciones>(acciones: T): T {
  const ultimas = useRef(acciones);
  ultimas.current = acciones;
  return useMemo(() => {
    const estables: Record<string, unknown> = {};
    for (const clave of Object.keys(ultimas.current)) estables[clave] = (...args: unknown[]) => ultimas.current[clave]!(...args);
    return estables as T;
  }, []);
}
